import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  Divider
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "react-i18next";
import { ROUTES } from 'consts';
import { withRouter, useHistory } from 'react-router-dom';
import { useUser } from 'components/hooks';
import { useTheme } from '@mui/material/styles';


const UserProfile = ({ username = '' }) => {
  const [t] = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const theme = useTheme();
  const { signOut, roles, roleSelected, setRoleSelected, user } = useUser();
  const handleClick = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeRole = (roleId) => {
    setRoleSelected(roleId);
    handleClose();
  };

  const options = [];

  if (user.admin) {
    options.push(...[{ label: 'Admin' }, { label: 'divider' }])
  } else if (roles.length > 0) {
    options.push(
      ...roles.map((role) => ({
        label: role.roleName,
      })),
      { label: 'divider' },
    );
  }

  options.push(...[
    {
      label: 'navbar.profile.changePassword',
      action: () => history.push(ROUTES.CHANGE_PASSWORD)
    },
    {
      label: 'navbar.profile.logout',
      action: () => {
        signOut();
        history.go(0);
      }
    }
  ]);

  return (
    <>
      <Button
        id="profile-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ p: 0, textTransform: 'inherit', color: theme.palette.common.white  }}
      >
        <Avatar sx={{ bgcolor: theme.palette.secondary[500], mr: 1 }}>{username[0] && username[0].toUpperCase()}</Avatar>
        <Typography variant="subtitle1" noWrap >
          {username}
        </Typography>
        <KeyboardArrowDownIcon sx={{ color: 'white', ml: 1, transform: open ? 'rotateZ(180deg)' : 'inherit', transition: '.3s' }}/>
      </Button>
      <Menu
        id="profile-menu"
        sx={{ mt: 1}}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'profile-button',
        }}
      >
        { options.map((option, index) => {
          if (option.label === 'divider') return <Divider key={index} />
          return (
            <MenuItem key={`${index}-menu`} onClick={option.action} sx={option.sx}>
              <Typography sx={{ pl: 1 }}>
                {t(option.label)}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  )
}

export default withRouter(UserProfile);
